import { CircleItem } from "@/types/circle"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface CircleStore {
  circles: CircleItem[]
  selectedCircleId: string
  loading: boolean
  setLoading: (loading: boolean) => void
  setCircles: (circles: CircleItem[]) => void
  selectCircle: (circleIndex: number) => void
}

const getCircleId = (circles: CircleItem[], circleIndex: number): string => {
  if (circleIndex < 0 || circleIndex >= circles.length) {
    return ""
  }

  const circle = circles[circleIndex]
  return circle.id
}

export const useCircleStore = create<CircleStore>()(
  devtools(
    (set, get) => ({
      circles: [],
      selectedCircleId: "",
      loading: false,
      setLoading: (loading: boolean) => {
        set({ loading })
      },
      setCircles: (circles: CircleItem[]) => {
        const selectedCircleId = getCircleId(circles, 0)
        set({ circles, selectedCircleId })
      },
      selectCircle: (circleIndex: number) => {
        const { circles } = get()
        const selectedCircleId = getCircleId(circles, circleIndex)
        if (selectedCircleId.length > 0) {
          set({ selectedCircleId })
        } else {
          console.error(
            `Tried to select out of bound circle: ${circleIndex} out of ${circles.length} options.`,
          )
        }
      },
    }),
    { name: "circle-store", enabled: process.env.NODE_ENV !== "production" },
  ),
)
